module.exports = __webpack_public_path__ + "img/green-price.fe66e46e.svg";